{
  "Changelog": "Plattformsändringar",
  "Admin": "Admin",
  "Before": "Före",
  "After": "Efter",
  "Changes": "Ändringar",
  "Bugs": "Buggar",
  "Unfixed": "Olöst",
  "Fixed": "Löst",
  "Upcoming": "Kommande",
  "addition": "Tillägg",
  "added": "Tillagt",
  "changed": "Ändrat"
}
